import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DigitalFooter.scss';
import logo from '../../assets/images/Logo Kanem Black.png';

const DigitalFooter = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        document.documentElement.dir = code === 'ar' ? 'rtl' : 'ltr';
    };

    return (
        <footer className="df-footer">
            <div className="df-inner">
                <div className="df-top">
                    <div className="df-brand">
                        <img src={logo} alt="KANEM" className="df-logo" />
                        <p>Solutions digitales pour entreprises ambitieuses.</p>
                    </div>

                    <div className="df-links">
                        <div className="df-col">
                            <h4>{t('footer.services')}</h4>
                            <Link to="/services/creation-site-web">{t('services.web.title')}</Link>
                            <Link to="/services/reseaux-sociaux">{t('services.social.title')}</Link>
                            <Link to="/solutions/automatisation">Automatisations IA</Link>
                        </div>
                        <div className="df-col">
                            <h4>{t('footer.navigation')}</h4>
                            <Link to="/">{t('nav.home')}</Link>
                            <Link to="/a-propos">{t('nav.about')}</Link>
                            <Link to="/contact">{t('nav.contact')}</Link>
                        </div>
                        <div className="df-col">
                            <h4>{t('footer.legal')}</h4>
                            <Link to="/politique-confidentialite">{t('footer.privacy')}</Link>
                            <Link to="/conditions-utilisation">{t('footer.terms')}</Link>
                            <Link to="/mentions-legales">{t('footer.mentions')}</Link>
                        </div>
                    </div>
                </div>

                <div className="df-bottom">
                    <p>© {new Date().getFullYear()} KANEM. {t('footer.copyright')}</p>
                    <div className="df-lang">
                        {['fr', 'en', 'ar', 'es'].map(code => (
                            <button
                                key={code}
                                className={i18n.language === code ? 'active' : ''}
                                onClick={() => changeLanguage(code)}
                            >
                                {code.toUpperCase()}
                            </button>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default DigitalFooter;
